module.exports = __webpack_public_path__ + "img/facebook.20107ba4.png";